import React from "react";
import banking from "../../../../constants/bankImg.json";

const partners = [
  { label: "Kreditbee", value: "/assets/bank_img/kreditbee_new.png" },
  { label: "Zype", value: "/assets/bank_img/zype_new.png" },
  { label: "Niro", value: "/assets/bank_img/niro_new.png" },
  { 
    label: "ABFL", 
    value: "/assets/bank_img/abfl_new.png", 
    url: "https://www.adityabirlacapital.com/loans", 
  },
  { label: "Olyv", value: "/assets/bank_img/olyv_new.png" },
  { label: "Unity", value: "/assets/bank_img/unity_new.png" },
  {
    label: "L&T",
    value: "/assets/bank_img/lnt.png",
    url: "https://www.ltfs.com/",
  },
  {
    label: "Poonawalla",
    value: "/assets/bank_img/poonawalla_new.png",
    url: "https://poonawallafincorp.com/digital-partnership.php",
  },
  { label: "DBS", value: "/assets/bank_img/dbs_new.png" },
  { label: "Lendingplate", value: "/assets/bank_img/lendingplate_new.png" },
  {
    label: "Incred",
    value: "/assets/bank_img/InCred Fin.png",
    url: "https://web.digitmoney.in/incred-grievance",
  },
  { label: "Fatakpay", value: "/assets/bank_img/Fatakpay.png" },
  { label: "Ramfincorp", value: "/assets/bank_img/ramfincorp.png" },
  { label: "Mpokket", value: "/assets/bank_img/Mpokket.png" },
  { label: "Moneyview", value: "/assets/bank_img/moneyview.png" },
  { label: "Tata Capital", value: "/assets/bank_img/tatacapital.png" },
  { label: "IndusInd Bank", value: "/assets/bank_img/IndusInd Bank.png" },
  { label: "Truebalance", value: "/assets/bank_img/Truebalance.png" },
  { label: "CreditSea", value: "/assets/bank_img/Creditsea.png" },
  { label: "DMIFinance", value: "/assets/bank_img/DMI2.png" },
  { label: "HDB Financial service", value: "/assets/bank_img/HBD.png" },
  {
    label: "Godrej Finance Limited",
    value: "/assets/bank_img/Godrej capital.png",
    url: "/godrej-finance-limited-grievance",
  },
  { label: "Nira", value: "/assets/bank_img/Nira.png" },
  { label: "Hero Fincorp", value: "/assets/bank_img/HeroFincorp.png" },
  { label: "Proitum", value: "/assets/bank_img/Protium.png" },
  { label: "Kissht", value: "/assets/bank_img/Kissht.png" },
  { label: "BharatPe", value: "/assets/bank_img/Bharatpe.png" },
];

const DigitalLendingPartners = () => {
  return (
    <section className="px-4 py-12 xs:py-5 md:px-12 lg:px-24 text-left">
      <h2 className="text-3xl xs:text-2xl md:text-6xl font-bomstad-semibold text-gray-800 mb-2">
        Our Digital Lending Partners
      </h2>
      <p className="text-gray-600 text-md xs:text-sm max-w-5xl font-atkinson mb-12 leading-snug">
        We don’t just generate leads; we help you acquire long-term customers
        through data-driven strategies tailored to your business goals.
      </p>

      <div className="grid grid-cols-2 gap-2 sm:gap-4 md:gap-6 lg:gap-8 mt-5 sm:grid-cols-3 md:grid-cols-4">
        {partners.map((partner, idx) => (
          <div
            key={idx}
            onClick={() => {
              if (partner.url) {
                window.open(partner.url, "_blank");
              }
            }}
            className={`rounded-lg p-3  sm:p-4 flex  flex-col bg-white items-center justify-center hover:shadow-md transition-shadow ${
              partner.url ? "cursor-pointer" : ""
            }`}
          >
            <div className="flex  items-center justify-center h-[170px] xs:h-[150px] xs:w-[125%]  ">
              <img
                src={partner.value}
                alt={partner.label}
                className="object-contain  h-full w-full xs:w-full max-w-full "
              />
            </div>

            {partner.label === "DMIFinance" && (
              <a
                href="https://www.dmifinance.in/wp-content/uploads/2025/10/loan-application-undertaking-English.pdf"
                target="_blank"
                className="text-[10px] xs:text-[7px] mt-1 text-gray-500"
              >
                DMI Loan Application Terms & Undertaking
              </a>
            )}
            <hr className="h-[2px] bg-red-600 w-[90%] mb-2" />

            <p className="text-[10px] xs:text-[7px] mt-1 text-gray-500">
              Grievance Redressal Officer:
            </p>
            <p className="text-[10px] xs:text-[7px] text-gray-500">
              Ammy Pinheiro
            </p>
            {/* <p className="text-[10px] xs:text-[7px] text-gray-500"></p> */}
            <a
              className="text-[10px] xs:text-[7px] text-gray-500"
              href="mailto: hello@digitmoney.in"
            >
              grievance@digitmoney.in
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DigitalLendingPartners;
